
<app-navbar></app-navbar>
<div class="page-title-area page-title-bg1 upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'Checkout' | translate }}</h2>
            <!--<a routerLink="/">{{'Home' | translate }}</a>-->
        </div>
    </div>
</div>
<!-- End -->
<!-- Start Checkout Area -->


<section class="checkout-area ptb-100">
    <div class="container">
        <!--         <div class="user-actions">
                    <i class='bx bx-log-in'></i>
                    <span>Returning customer? <a routerLink="/login">Click here to login</a></span>
                </div> -->

        <form>
            <div class="row d-flex align-items-top">
                <!-- data-aos="fade-up" data-aos-delay="100"-->
                <div class="col-lg-6 col-md-12">
                    <div class="billing-details card">
                        <h3 class="title">{{ 'Billing_Details' | translate }}</h3>

                        <div class="form-grid">
                            <!-- Name -->
                            <div class="form-field">
                                <label for="clientName">{{ 'Name' | translate }} <span class="required">*</span></label>
                                <input id="clientName"
                                       type="text"
                                       class="form-control"
                                       required
                                       #clientName="ngModel"
                                       name="clientName"
                                       [(ngModel)]="mainForm.clientName"
                                       (ngModelChange)="onSenderChange()" />
                            </div>

                            <!-- Phone -->
                            <div class="form-field">
                                <label for="phone">{{ 'Phone_No' | translate }} <span class="required">*</span></label>
                                <input id="phone"
                                       type="text"
                                       required
                                       ng2TelInput
                                       #phone_number
                                       name="phone_number"
                                       class="form-control"
                                       [(ngModel)]="mainForm.phoneNo"
                                       (ngModelChange)="onSenderChange()"
                                       [(value)]="phone_number_standard"
                                       (countryChange)="onCountryChange($event)"
                                       [ng2TelInputOptions]="telOptions" />
                            </div>

                            <!-- Delivery Method -->
                            <div class="form-field">
                                <label for="deliveryMethod">{{ 'Delivery_Method' | translate }} <span class="required">*</span></label>
                                <select id="deliveryMethod"
                                        class="form-select"
                                        #deliveryMethod="ngModel"
                                        name="deliveryMethod"
                                        [(ngModel)]="mainForm.deliveryMethod"
                                        (change)="onDeliveryMethod()">
                                    <option value="Receive from Store">{{ 'Receive_from_Store' | translate }}</option>
                                    <option value="Delivery to Client">{{ 'Delivery_To_Home' | translate }}</option>
                                </select>
                            </div>

                            <!-- Address Selects -->
                            <ng-container *ngFor="let idx of [1,2,3,4,5]">
                                <div class="form-field" *ngIf="this['isAddressDelivery' + idx]">
                                    <label>
                                        {{ this['addressDeliveryName' + idx] }}
                                        <span class="required">*</span>
                                    </label>
                                    <select class="form-select"
                                            [name]="'deliveryMethod' + idx"
                                            [(ngModel)]="this['addressDeliveryValue' + idx]"
                                            (change)="this['onAddressDelivery' + idx]()">
                                        <option *ngFor="let option of this['addressDeliveryData' + idx]" [value]="option.inDeliveryAddressID">
                                            {{ SelectedLanguage == 'ar' ? option.nameAr : option.nameEn }}
                                        </option>
                                    </select>
                                </div>
                            </ng-container>

                            <!-- Notes -->
                            <div class="form-field full-width">
                                <label for="notes">{{ 'Notes' | translate }}</label>
                                <textarea id="notes"
                                          name="notes"
                                          rows="4"
                                          placeholder="{{ 'Order_Notes' | translate }}"
                                          class="form-control"></textarea>
                            </div>
                        </div>
                    </div>





                </div>
                <!-- data-aos="fade-up" data-aos-delay="300"-->
                <div class="col-lg-6 col-md-12">
                    <div class="order-details card">
                        <h3 class="title">{{ 'Your_Order' | translate }}</h3>

                        <div class="order-items">
                            <div *ngFor="let product of products" class="order-item">
                                <div class="item-name">
                                    <ng-template *ngIf="SelectedLanguage == 'ar'; then other_ItemAr; else other_ItemEn"></ng-template>
                                    <ng-template #other_ItemAr>{{ product.nameAr }}</ng-template>
                                    <ng-template #other_ItemEn>{{ product.name }}</ng-template>
                                </div>
                                <div class="item-price">
                                    {{ ( product.cartQuantity * (((product.saleTaxPercentage /100) * product.cartPrice) + product.cartPrice)).toFixed(3) }}
                                </div>
                            </div>
                        </div>

                        <div class="order-summary">
                            <div class="summary-row">
                                <span>{{ 'Cart_Subtotal' | translate }} <small>*{{ 'Including_VAT' | translate }}</small></span>
                                <span>{{ total | number : '1.3-6' }}</span>
                            </div>

                            <div class="summary-row">
                                <span>{{ 'VAT' | translate }}</span>
                                <span>{{ mainForm.totalTax | number : '1.3-6' }}</span>
                            </div>

                            <div class="summary-row promo-code">
                                <span>{{ 'Promotion_Code' | translate }}</span>
                                <div class="promo-input">
                                    <input type="text"
                                           class="form-control"
                                           name="promotionCode"
                                           [(ngModel)]="mainForm.promotionCode"
                                           [disabled]="isDisabledVoucher"
                                           placeholder="{{'Enter_Code' | translate}}" />
                                    <button type="button"
                                            class="btn btn-primary"
                                            (click)="onPromotionCode()"
                                            [disabled]="isDisabledVoucher">
                                        <i class="bx bx-search"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="summary-row" *ngIf="discount > 0">
                                <span>{{ 'Discount' | translate }}</span>
                                <span>- {{ discount | number : '1.3-6' }}</span>
                            </div>

                            <div class="summary-row" *ngIf="mainForm.serviceCharge > 0">
                                <span>{{ 'Delivery' | translate }}</span>
                                <span>{{ mainForm.serviceCharge | number : '1.3-6' }}</span>
                            </div>
                        </div>

                        <div class="order-total">
                            <span>{{ 'Order_Total' | translate }}</span>
                            <span class="total-amount">{{ mainForm.amount | number : '1.3-6' }}</span>
                        </div>
                    </div>

                </div>

                <div class="col-lg-12 col-md-12">
                    <!---->
                    <div class="payment-box">
                        <div class="payment-method">
                            <div class="form-check">

                                <input type="checkbox"
                                       class="form-check-input"
                                       #orderNo
                                       name="orderNo" />&nbsp;

                                <label for="orderNo" class="form-check-label">
                                    {{ 'I_have_read_and_agree_to_the_website' | translate }}
                                    <a target="_blank" routerLink="/terms" class="terms-link">
                                        {{ 'Terms_and_Conditions' | translate }}
                                    </a>*
                                </label>
                            </div>
                        </div>

                        <button type="submit" class="default-btn" (click)="onOrder(orderNo.checked)">
                            {{ 'Place_Order' | translate }}
                        </button>

                        <div class="payment-image">
                            <img src="../../../../assets/img/Payment.jpg" alt="Payment Methods" />
                        </div>
                    </div>

                    <!---->
                </div>
            </div>
        </form>
    </div>
</section>
<!-- End Checkout Area -->
